import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { ToggleEntry } from './ToggleEntry.js';
import { LogProvider } from '../Providers/LogProvider.js';
import style from './LevelSettings.css';
import { LogUploader } from "./LogUploader";
import React from "react";
export var Settings = /*#__PURE__*/function (_Component) {
  _inherits(Settings, _Component);

  var _super = _createSuper(Settings);

  function Settings() {
    _classCallCheck(this, Settings);

    return _super.apply(this, arguments);
  }

  _createClass(Settings, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        className: style.settings + ' popovermenu bubble open menu'
      }, /*#__PURE__*/React.createElement("h4", null, t('logreader', 'Log levels')), LogProvider.levels.map(function (name, level) {
        return /*#__PURE__*/React.createElement(ToggleEntry, {
          key: level,
          active: _this.props.levels[level],
          onChange: _this.props.setLevel.bind(_this, level)
        }, name);
      }), /*#__PURE__*/React.createElement("h4", null, t('logreader', 'Log content')), /*#__PURE__*/React.createElement(ToggleEntry, {
        active: this.props.live,
        onChange: this.props.setLive
      }, t('logreader', 'Live update')), /*#__PURE__*/React.createElement(LogUploader, {
        onLogFile: this.props.onLogFile
      }), /*#__PURE__*/React.createElement("a", {
        href: OC.generateUrl('settings/admin/log/download'),
        className: "button"
      }, t('logreader', 'Download logs')));
    }
  }]);

  return Settings;
}(Component);